// // Material Dashboard 2 React context
// import { useMaterialUIController } from "context";

// // Images
// import masterCardLogo from "assets/images/logos/mastercard.png";
// import visaLogo from "assets/images/logos/visa.png";

// @mui material components
import {
  Snackbar,
  Alert,
  // AlertTitle,
  Grid,
  Card,
  Icon,
  // Tooltip,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  LinearProgress,
  TextField,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useAuthUser } from "react-auth-kit";

import BalanceOverviewCard from "app/wallet/BalanceOverviewCard";
import Transaction from "app/wallet/Transaction";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import { Link } from "react-router-dom";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
// import MDBadge from "theme/components/MDBadge";

// import { confirm } from "react-confirm-box";

function WalletPage() {
  const pageTitle = `Wallet`;
  usePageTitle(pageTitle);

  const auth = useAuthUser();
  const accountInfo = auth();

  function emptyCache() {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }

  function versionRefresh() {
    emptyCache();
    window.location.reload();
  }

  function appVersionCheck(newVersion) {
    // Handle App Update
    const currentVersion = localStorage.getItem(AppConfig.app_version_store);
    let shouldUpdate = false;
    if (currentVersion !== newVersion) {
      shouldUpdate = true;
    }
    localStorage.setItem(AppConfig.app_version_store, newVersion);

    if (shouldUpdate) {
      if (
        window.confirm(
          "A new version is available. App will automatically refresh to get the latest update."
        ) === true
      ) {
        versionRefresh();
      } else {
        versionRefresh();
      }
    }
  }

  const [refreshPage, setRefreshPage] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [currency, setCurrency] = useState({});
  const [balance, setBalance] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [vbank, setVbank] = useState(null);

  const [openVbankDialog, setOpenVbankDialog] = useState(false);
  const [openWithdrawDialog, setOpenWithdrawDialog] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState(null);
  const [destinationType, setDestinationType] = useState(null);
  const [narration, setNarration] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [accountName, setAccountName] = useState(null);
  const [agentRef, setAgentRef] = useState(null);
  const [banks, setBanks] = useState([]);
  const [showInlineLoading, setShowInlineLoading] = useState(false);
  const [withdrawalFeesObject, setWithdrawalFeesObject] = useState({});
  const [withdrawalFee, setWithdrawalFee] = useState(null);
  const [transferEnabled, setTransferEnabled] = useState(false);

  // const [licensePlan, setLicensePlan] = useState(null);
  // const [currentSubscription, setCurrentSubscription] = useState(null);
  // const [subscriptionPaymentDuration, setSubscriptionPaymentDuration] = useState(null);
  // const [openSubscriptionPaymenttDialog, setOpenSubscriptionPaymenttDialog] = useState(false);

  const [uploadFile, setUploadFile] = useState(null);
  const [openBulkPayoutDialog, setOpenBulkPayoutDialog] = useState(false);

  useEffect(() => {
    if (destinationType === null) {
      return;
    }

    // if (destinationType === "ALERO") {
    //   setWithdrawalFee("FREE");
    // } else {
    //   setWithdrawalFee("N75.00");
    // }
    setWithdrawalFee(withdrawalFeesObject[destinationType]);
  }, [destinationType]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/wallet.json`)
        .then((result) => {
          setShowLoading(false);
          // console.log(result);
          if (result.data.status === "success") {
            setCurrency(result.data.data.currency);
            setBalance(result.data.data.balance);
            setTransactions(result.data.data.entries);
            setVbank(result.data.data.vbank);
            setBanks(result.data.data.banks);
            setWithdrawalFeesObject(result.data.data.withdrawal_fee);
            setTransferEnabled(result.data.data.transferEnabled);
            // setLicensePlan(result.data.data.subscription.license);
            // setCurrentSubscription(result.data.data.subscription.subscription);
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }

          appVersionCheck(result.data.version);
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  // async function paySubscription() {
  //   if (subscriptionPaymentDuration == null || subscriptionPaymentDuration <= 0) {
  //     setSeverity("error");
  //     setErrMsg("Please select a duration");
  //     setOpen(true);
  //     return;
  //   }

  //   setOpenSubscriptionPaymenttDialog(false);
  //   setShowLoading(true);
  //   const json = {
  //     duration: subscriptionPaymentDuration,
  //   };

  //   await axios
  //     .post("portal/license/subscription/pay.json", json)
  //     .then((result) => {
  //       setShowLoading(false);
  //       if (result.data.status === "success") {
  //         setSeverity("success");
  //         setErrMsg(result.data.data.message);
  //         setOpen(true);

  //         setRefreshPage(!refreshPage);
  //       } else {
  //         setSeverity("error");
  //         setErrMsg(result.data.data.message);
  //         setOpen(true);
  //       }
  //     })
  //     .catch(() => {
  //       setShowLoading(false);
  //       setSeverity("error");
  //       setErrMsg(
  //           `Unable to complete request. ${
  //             navigator.onLine ? "" : "Make sure you have an active internet connection"
  //           }`
  //         );
  // //       setOpen(true);
  // //     });
  // // }

  async function vbankCreate() {
    setShowLoading(true);
    const json = {};

    await axios
      .post("account/vbank/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function fetchAccountName() {
    setShowInlineLoading(true);
    const json = {
      type: destinationType,
      destination:
        destinationType === "BANK"
          ? { bank_code: selectedBank, account_number: accountNumber }
          : agentRef,
    };

    await axios
      .post("portal/wallet/withdraw/getAccountName.json", json)
      .then((result) => {
        setShowInlineLoading(false);
        if (result.data.status === "success") {
          setAccountName(result.data.data.account_name);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowInlineLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const destinationNameLookup = () => {
    setAccountName(null);
    if (destinationType === "BANK") {
      if (selectedBank === null || accountNumber === null) {
        return;
      }
    }

    if (destinationType === "AGENT") {
      if (agentRef === null) {
        return;
      }
    }

    fetchAccountName();
  };

  async function withdrawFunds() {
    if (!transferEnabled) {
      setSeverity("error");
      setErrMsg("Transfer is not enabled for this account.");
      setOpen(true);
      return;
    }

    if (withdrawAmount === null || withdrawAmount <= 0) {
      setSeverity("error");
      setErrMsg("Invalid amount entered.");
      setOpen(true);
      return;
    }

    if (destinationType === null) {
      setSeverity("error");
      setErrMsg("Destination type is required");
      setOpen(true);
      return;
    }

    let destinationObject = {};
    if (destinationType === "BANK") {
      if (selectedBank === null) {
        setSeverity("error");
        setErrMsg("Bank is required");
        setOpen(true);
        return;
      }

      if (accountNumber === null) {
        setSeverity("error");
        setErrMsg("Account number is required");
        setOpen(true);
        return;
      }

      if (accountName === null) {
        setSeverity("error");
        setErrMsg("Account name not found");
        setOpen(true);
        return;
      }

      destinationObject = {
        bank_code: selectedBank,
        account_number: accountNumber,
        account_name: accountName,
      };
    }

    if (["AGENT", "AGGREGATOR"].includes(destinationType)) {
      if (agentRef === null) {
        setSeverity("error");
        setErrMsg(`${destinationType === "AGENT" ? "Agent" : "Supervisor"} is required`);
        setOpen(true);
        return;
      }

      destinationObject = agentRef;
    }

    setOpenWithdrawDialog(false);
    setShowLoading(true);
    const json = {
      amount: withdrawAmount * 100,
      currency: "NGN",
      destination: {
        type: destinationType,
        destination: destinationObject,
      },
      narration: narration ? narration : "Laddar Africa Payout",
    };

    await axios
      .post("portal/wallet/withdraw.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function fileSelected(e, any = false) {
    e.persist();
    if (!any) {
      const fileTypes = ["xlsx", "xls", "csv"];
      const file = e.target.files[0];
      const extension = file.name.split(".").pop().toLowerCase();
      const supported = fileTypes.indexOf(extension) > -1;
      if (!supported) {
        setSeverity("error");
        setErrMsg("Only excel and csv files accepted.");
        setOpen(true);
        return;
      }
    }

    setUploadFile(e.target.files[0]);
  }

  async function uploadBulkAgentPayout() {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenBulkPayoutDialog(false);
    setShowLoading(true);

    await axios
      .post("portal/wallet/transfers/agents/bulk.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg("Upload successful.");
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {vbank ? (
        <Dialog open={openVbankDialog} fullWidth maxWidth="sm">
          <DialogTitle>
            <MDBox>Deposit Bank Account</MDBox>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <MDBox>Pay to the bank details below to fund your Laddar wallet.</MDBox>
            </DialogContentText>
            <MDBox mt={3}>
              <TableContainer component={Paper}>
                <Table aria-label="bank information">
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant="h6" fontWeight="medium">
                          Bank Name
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="h6" fontWeight="light">
                          {vbank.bank_name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant="h6" fontWeight="medium">
                          Account Name
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="h6" fontWeight="light">
                          {vbank.account_name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant="h6" fontWeight="medium">
                          Account Number
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="h6" fontWeight="light">
                          {vbank.account_number}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <MDBox mt={3}>
                <Alert severity="info">
                  Payment processing fee applies on all deposits. View Billing to see applicable
                  fees.
                </Alert>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenVbankDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Close
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog open={openVbankDialog} fullWidth maxWidth="sm">
          <DialogTitle>
            <MDBox>Deposit Bank Account</MDBox>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <MDBox>You have not created your wallet deposit bank account.</MDBox>
            </DialogContentText>
            <MDBox mt={1} p={3}>
              <ul>
                <li>Fund wallet</li>
                <li>Accept cash from customers</li>
                <li>Laddar wallet will be debitted</li>
                <li>Voucher displayed and sent to customer</li>
              </ul>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenVbankDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Close
            </MDButton>
            <MDButton
              onClick={() => {
                setOpenVbankDialog(false);
                vbankCreate();
              }}
              color="dark"
              variant="contained"
            >
              Create
            </MDButton>
          </DialogActions>
        </Dialog>
      )}
      <Dialog open={openWithdrawDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Funds Transfer</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>Transfer funds from your Laddar wallet.</MDBox>
          </DialogContentText>

          <MDBox mt={3}>
            <FormControl sx={{ minWidth: 120, width: "100%" }}>
              <InputLabel>Transfer To</InputLabel>
              <Select
                label="Transfer To"
                onChange={(e) => {
                  setAccountName(null);
                  setDestinationType(e.target.value);
                }}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                {/* <MenuItem value="ALERO">Alero Account</MenuItem> */}
                <MenuItem value="BANK">Bank Account</MenuItem>
                <MenuItem value="AGENT">Agent</MenuItem>
                <MenuItem value="AGGREGATOR">Supervisor</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
          {withdrawalFee !== null && destinationType !== null && (
            <MDBox mt={1} align="right">
              <MDTypography variant="caption" fontWeight="medium" color="info">
                Fee: {withdrawalFee}
              </MDTypography>
            </MDBox>
          )}
          <MDBox mt={2}>
            <MDInput
              name="amount"
              margin="dense"
              label="Enter Amount"
              type="decimal"
              fullWidth
              variant="outlined"
              onChange={(e) => setWithdrawAmount(e.target.value)}
            />
          </MDBox>
          <MDBox mt={2}>
            <MDInput
              multiline
              minRows={3}
              name="narration"
              margin="dense"
              label="Remarks"
              type="text"
              fullWidth
              variant="outlined"
              onChange={(e) => setNarration(e.target.value)}
            />
          </MDBox>
          {destinationType !== null && (
            <MDBox>
              {destinationType === "BANK" ? (
                <MDBox>
                  <MDBox mt={4} mb={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Bank</InputLabel>
                      <Select
                        label="Bank"
                        onBlur={destinationNameLookup}
                        onChange={(e) => {
                          setSelectedBank(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {
                          // --> Notice below changes
                          banks.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            banks.map((record) => (
                              <MenuItem value={record.sort_code}>{record.title}</MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </MDBox>
                  <MDBox mt={2}>
                    <MDInput
                      name="amount"
                      margin="dense"
                      label="Account Number"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setAccountNumber(e.target.value)}
                      onBlur={destinationNameLookup}
                    />
                  </MDBox>
                  {showInlineLoading && (
                    <MDBox m={3}>
                      &nbsp;&nbsp;
                      <LinearProgress color="info" />
                    </MDBox>
                  )}
                  {accountName !== null && (
                    <MDBox mt={2}>
                      <MDInput
                        value={accountName}
                        disabled
                        readOnly
                        name="accountName"
                        margin="dense"
                        label="Account Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                      />
                    </MDBox>
                  )}
                </MDBox>
              ) : (
                <MDBox>
                  <MDBox mt={2}>
                    <MDInput
                      name="amount"
                      margin="dense"
                      label="Email / Phone Number"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setAgentRef(e.target.value)}
                      onBlur={destinationNameLookup}
                    />
                  </MDBox>
                  {destinationType === "AGENT" && (
                    <MDBox mt={5}>
                      <MDButton
                        size="small"
                        sx={{ width: "100%" }}
                        onClick={() => {
                          setOpenWithdrawDialog(false);
                          setOpenBulkPayoutDialog(true);
                        }}
                        color="dark"
                        variant="outlined"
                      >
                        Bulk Transfer?
                      </MDButton>
                    </MDBox>
                  )}
                  {showInlineLoading && (
                    <MDBox m={3}>
                      &nbsp;&nbsp;
                      <LinearProgress color="info" />
                    </MDBox>
                  )}
                  {accountName !== null && (
                    <MDBox mt={2}>
                      <MDInput
                        value={accountName}
                        disabled
                        readOnly
                        name="accountName"
                        margin="dense"
                        label="Account Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                      />
                    </MDBox>
                  )}
                </MDBox>
              )}
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenWithdrawDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Close
          </MDButton>
          <MDButton
            onClick={() => {
              // setOpenWithdrawDialog(false);
              withdrawFunds();
            }}
            color="dark"
            variant="contained"
          >
            Transfer
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openBulkPayoutDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Bulk Agent Transfer</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={4}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
                fullWidth
              />
              <br />
              <MDTypography variant="h6" color="info" fontSize="small" fontWeight="light" mt={1}>
                Fields: agent, amount, currency, narration
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenBulkPayoutDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadBulkAgentPayout();
            }}
          >
            Upload File
          </MDButton>
        </DialogActions>
      </Dialog>
      {/* <Dialog open={openSubscriptionPaymenttDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Subscription Payment</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Duration</InputLabel>
                <Select
                  label="Duration"
                  onChange={(e) => {
                    setSubscriptionPaymentDuration(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >\
                  <MenuItem value="1">1 Month</MenuItem>
                  <MenuItem value="3">3 Months</MenuItem>
                  <MenuItem value="6">6 Months</MenuItem>
                  <MenuItem value="12">12 Months</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSubscriptionPaymenttDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (window.confirm(`Proceed with payment?`) === true) {
                paySubscription();
              }
            }}
          >
            Pay Now
          </MDButton>
        </DialogActions>
      </Dialog> */}
      <MDBox pt={6} pb={3}>
        <MDBox>
          <MDBox mb={1.5}>
            <BalanceOverviewCard
              idx="balance"
              color="success"
              icon="account_balance_wallet"
              // currencyCode={currency}
              symbol={currency.symbol}
              amount={balance}
              title="Balance"
            />
          </MDBox>
          <MDBox mt={3}>
            <Card sx={{ width: "100%" }}>
              <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between">
                  <MDButton
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      if (!vbank) {
                        setErrMsg("Feature not available.");
                        setSeverity("warning");
                        setOpen(true);
                        return;
                      }

                      setOpenVbankDialog(true);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;Deposit
                  </MDButton>
                  &nbsp;
                  <MDButton
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      // if (!isAleroLinked) {
                      //   setErrMsg("Please link your Alero account to enable this feature.");
                      //   setSeverity("error");
                      //   setOpen(true);
                      //   return;
                      // }

                      if (!transferEnabled) {
                        setErrMsg("This feature is not enabled.");
                        setSeverity("error");
                        setOpen(true);
                        return;
                      }

                      setDestinationType(null);
                      setSelectedBank(null);
                      setAccountNumber(null);
                      setAccountName(null);
                      setWithdrawAmount(null);
                      setWithdrawalFee(null);
                      setOpenWithdrawDialog(true);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                    &nbsp;Transfer
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
        <MDBox>
          <Card sx={{ width: "100%", marginTop: "35px" }}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={2}>
              <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                Recent Transactions
              </MDTypography>
              <MDBox alignContents="center">
                <MDButton
                  variant="outlined"
                  color="dark"
                  size="small"
                  onClick={() => {
                    const downloadUrl = `${AppConfig.api_base_url}portal/wallet/statement/${accountInfo.account.reference}/${accountInfo.user.reference}/export.json`;
                    window.open(downloadUrl, "_blank");
                  }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                  &nbsp;Statement
                </MDButton>
              </MDBox>
            </MDBox>
            {transactions === null ? (
              <MDBox pt={3} pb={2} px={2}>
                <MDBox
                  component="ul"
                  display="flex"
                  flexDirection="column"
                  p={0}
                  m={0}
                  sx={{ listStyle: "none" }}
                >
                  No recent transactions found
                </MDBox>
              </MDBox>
            ) : (
              <MDBox pt={3} pb={2} px={2}>
                <MDBox
                  component="ul"
                  display="flex"
                  flexDirection="column"
                  p={0}
                  m={0}
                  sx={{ listStyle: "none" }}
                >
                  {transactions.map((record, index) => (
                    <Grid item xs={12} md={12} lg={12}>
                      <MDBox mb={1.5}>
                        <Transaction
                          idx={index}
                          currency={record.currency}
                          entryType={record.entry_type}
                          narration={record.narration}
                          amount={record.amount}
                          created={record.created}
                        />
                      </MDBox>
                    </Grid>
                  ))}
                </MDBox>
              </MDBox>
            )}
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default WalletPage;
